import { makeStyles, createStyles } from '@material-ui/core/styles';

import { colors } from 'styles/colors';

const useStyles = makeStyles(() =>
  createStyles({
    drawerMenu: {
      background: colors.white,
      '& .MuiPaper-root': {
        boxShadow:
          '0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2)',
      },
    },
    menuList: {
      marginTop: '72px',
    },
  }),
);

export default useStyles;
